enum VisibilityStateEnum {
	hidden = 'hidden',
	visible = 'visible',
	prerender = 'prerender'
}
export default VisibilityStateEnum;
